
import { FolderRoot, Loader2 } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

import { useUpdateFolderMutation } from "@/modules/mine";
import { getFolderParentIdById } from "@/modules/mine";
import { FolderSelector } from "@/modules/mine/components/folder-selector";
import type { Folder } from "@/modules/mine/navigation/types";
import type { DialogComponentProps } from "@/shared/components/dialog";
import { Button } from "@/shared/ui/button";
import { DialogFooter } from "@/shared/ui/dialog";

type MoveFolderResult = {
  action: "moved";
  folderId: string;
  parentId: string | null;
};

interface MoveFolderProps extends DialogComponentProps<MoveFolderResult> {
  folder: Folder;
  folders: Folder[];
}

export function MoveFolder({ close, resolve, folder, folders }: MoveFolderProps) {
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);
  const [hasSelectedFolder, setHasSelectedFolder] = useState(false);
  const [folderError, setFolderError] = useState("");
  const updateFolderMutation = useUpdateFolderMutation();
  return (
    <div>
      <div className="space-y-2 mb-6">
        <FolderSelector 
            filterFolderId={folder.id}
            returnDropdownContent 
            showSearch
            allowCreate
            allowEmpty={true}
            emptyLabel="顶级目录"
            emptyIcon={FolderRoot}
            value={selectedFolderId}
            emptySelected={hasSelectedFolder && selectedFolderId === null}
            onChange={(folderId) => {
              setSelectedFolderId(folderId);
              setHasSelectedFolder(true);
              setFolderError("");
            }} />
        {folderError && (
          <p className="text-sm text-destructive">{folderError}</p>
        )}
      </div>
      <DialogFooter>
        <Button
          type="button"
          variant="outline"
          onClick={close}
          disabled={updateFolderMutation.isPending}
        >
          取消
        </Button>
        <Button type="button" disabled={updateFolderMutation.isPending} onClick={() => {
          if (!hasSelectedFolder) {
            setFolderError("请选择目标目录");
            return;
          }

          const parentId = getFolderParentIdById(folder.id, folders);
          if (parentId === selectedFolderId) {
            close();
            return;
          }
          updateFolderMutation.mutate(
            {
              id: folder.id,
              parent_id: selectedFolderId || "0",
            },
            {
              onSuccess: () => {
                toast.success("移动成功");
                resolve({
                  action: "moved",
                  folderId: folder.id,
                  parentId: selectedFolderId,
                });
              },
            },
          );
        }}>
          {updateFolderMutation.isPending && <Loader2 className="animate-spin" />}确认
        </Button>
      </DialogFooter>
    </div>
  );
}
